import { FieldSelectMulti } from '@/components/looker/field-select-multi';
import { AlertStatus } from '@/task-manager/entities/alert-status';

export type AlertStatusFilterProps = {
  value?: AlertStatus[];
  onChange: (value?: AlertStatus[]) => void;
};

export function AlertStatusFilter({ value, onChange }: AlertStatusFilterProps) {
  return (
    <FieldSelectMulti
      data-testid="alert-status-filter"
      label="Alert status"
      placeholder="Filter by status"
      options={Object.values(AlertStatus).map((value) => ({ value }))}
      values={value}
      onChange={(values) =>
        onChange(
          Object.values(AlertStatus).filter(
            (v) => values?.includes(v.toString()) ?? [],
          ),
        )
      }
    />
  );
}
